module.exports = __webpack_public_path__ + "img/macbook-lms.369e4fb0.png";